import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import Divider from "@material-ui/core/Divider/Divider";
import Typography from "@material-ui/core/Typography/Typography";
import { withWidth } from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";
import { isWidthUp } from "@material-ui/core/withWidth";
import routes from "../../constants/routes";
import { WSO2_LOGIN_URL } from "../../constants/API";
import { Button, ErrorMessage, Footer } from "../../components";
import { backgroundImageUrl, MedsafeVerboseLogo } from "../../assets/images";

const styles = (theme: Theme) =>
  createStyles({
    button: {
      margin: `${theme.spacing(5)}px auto`,
      width: "100px",
      minHeight: "40px"
    },
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100vh"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "center",
      maxWidth: "800px",
      width: "100%",
      margin: "0 auto"
    },
    errorMessage: {
      marginBottom: theme.spacing(4),
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: "500px"
    },
    footer: {
      alignItems: "center",
      backgroundColor: "#F5F5F5",
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between",
      padding: theme.spacing(2)
    },
    footerLink: {
      margin: theme.spacing(2)
    },
    footerLinks: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    footerLogos: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    footerLogo: {
      margin: theme.spacing(2)
    },
    header: {
      alignItems: "center",
      backgroundImage: `url(${backgroundImageUrl})`,
      display: "flex",
      height: "150px",
      justifyContent: "center",
      width: "100%"
    },
    medsafeLogo: {
      margin: `${theme.spacing(5)}px 0`
    },
    title: {
      color: theme.palette.primary.dark,
      margin: `${theme.spacing(5)}px 0`,
      textAlign: "center"
    }
  });

type State = {
  ws02error: Error | null;
};
type Props = RouteComponentProps & {
  classes?: any;
  width: Breakpoint;
};

export class Login extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ws02error: null
    };
    this.onLogin = this.onLogin.bind(this);
  }

  componentDidMount() {
    const ws02error = localStorage.getItem("ws02error");
    if (ws02error) {
      window.localStorage.removeItem("ws02error");
      if (ws02error !== "invalid_request") {
        this.setState({
          ws02error: new Error(ws02error)
        });
      }
    }
  }

  onLogin() {
    window.location.href = WSO2_LOGIN_URL;
  }

  render() {
    const { classes, width } = this.props;
    const ws02error = this.state.ws02error;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <MedsafeVerboseLogo
            id="mcols-verbose-logo"
            className={classes.medsafeLogo}
          />
        </div>
        <div className={classes.content}>
          <Typography
            variant={isWidthUp("sm", width) ? "h1" : "h2"}
            component="h1"
            className={classes.title}
          >
            Medicines Control Online System
          </Typography>
          <Divider />
          <Button
            id="login"
            className={classes.button}
            color="primary"
            onClick={this.onLogin}
          >
            Login
          </Button>
          {ws02error && (
            <ErrorMessage className={classes.errorMessage} error={ws02error} />
          )}
        </div>
        <Footer
          links={[
            { url: routes.TERMS.url, label: routes.TERMS.label },
            { url: routes.SUPPORT.url, label: routes.SUPPORT.label }
          ]}
        />
      </div>
    );
  }
}

export const styled = withStyles(styles)(Login);
export default withRouter(withWidth()(styled));
